import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Card, Button } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from '../../utils/http/axios-local'

const ICONS = {
  dispute_overview: 'file-invoice-dollar',
  monthly_review_overview: 'file-invoice-dollar',
  rtr_overview: 'comment',
  alert_overview: 'exclamation-triangle',
  measure_analysts: 'user-friends',
  dispute_download: 'file-csv',
  inquiry_download: 'file-csv',
  alert_download: 'file-csv',
  analysts_download: 'file-csv'
}

const Reports = () => {
  const [links, setLinks] = useState({ dashboards: [], downloads: [] })
  const classes = useStyles()

  useEffect(() => {
    axios.get('/looker/merchant-reports').then(response => {
      const data = response?.data
        ?.sort((item1, item2) => item1?.order - item2?.order)
        .reduce(
          (hash, item) => {
            if (item?.remoteType === 'dashboard') {
              if (
                item.order > 1 &&
                !hash.dashboards.find(
                  element => element.order === item.order - 1
                )
              ) {
                hash.dashboards.push({
                  name: `Blank space ${item.order - 1}`,
                  link: '',
                  icon: '',
                  isBlank: true
                })
              }
              hash.dashboards.push(item)
            } else if (item.remoteType === 'download') {
              if (
                item.order > 1 &&
                !hash.downloads.find(
                  element => element.order === item.order - 1
                )
              ) {
                hash.downloads.push({
                  name: `Blank space ${item.order - 1}`,
                  link: '',
                  icon: '',
                  isBlank: true
                })
              }
              hash.downloads.push(item)
            }

            return hash
          },
          { dashboards: [], downloads: [] }
        )
      setLinks(data)
    })
  }, [])

  const dashboards = links.dashboards.map(dashboard => (
    <Button
      key={dashboard.name}
      className={`${classes.reportLink} ${classes.reportWidth}`}
      href={`/ui/looker/${dashboard.name}`}
    >
      <FontAwesomeIcon
        icon={ICONS[dashboard.name] || 'file-invoice-dollar'}
        size="2x"
        className={classes.icon}
      />
      {dashboard.displayName}
    </Button>
  ))

  const downloads = links.downloads.map(download => {
    if (download.isBlank) {
      return <div className={classes.reportWidth} />
    }

    return (
      <Button
        key={download.name}
        className={`${classes.reportLink} ${classes.reportWidth}`}
        href={`/ui/looker/${download.name}`}
      >
        <FontAwesomeIcon
          icon={ICONS[download.name] || 'file-csv'}
          size="2x"
          className={classes.icon}
        />
        {download.displayName}
      </Button>
    )
  })

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <div className={classes.groupTitle}>
          <FontAwesomeIcon
            icon="chart-bar"
            size="2x"
            className={classes.icon}
          />
          Analytics Dashboard
        </div>
        {dashboards}
      </Card>
      <Card className={classes.card}>
        <div className={classes.groupTitle}>
          <FontAwesomeIcon
            icon="file-download"
            size="2x"
            className={classes.icon}
          />
          Data Downloads
        </div>
        {downloads}
      </Card>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    padding: 20,
    margin: 20
  },
  groupTitle: {
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    width: 280
  },
  icon: {
    marginRight: 12
  },
  reportLink: {
    textTransform: 'none',
    backgroundColor: '#E9EAF7'
  },
  reportWidth: {
    width: 240,
    marginRight: 20
  }
}))
export default Reports
